import React, { useEffect } from 'react'
import { Field, reduxForm, change } from 'redux-form'

import { FormButtons, renderers, validations } from '../../../components'
import { useSelector } from 'react-redux'

const FORM_NAME = 'invite-token-customer-form'
let InviteCustomerForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  dispatch,
}) => {
  const { counterNumber } = useSelector((state) => state.machineConfig)

  useEffect(() => {
    counterNumber &&
      dispatch(change(FORM_NAME, 'counter_number', counterNumber))
  }, [counterNumber, dispatch])

  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={renderers.renderSelectField}
        as="select"
        validate={[validations.required]}
        name="counter_number"
        label="Counter Number"
      >
        {Array(50)
          .fill(1)
          .map((x, y) => x + y)
          .map((country) => {
            return (
              <option key={country} value={country}>
                {country}
              </option>
            )
          })}
      </Field>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}

InviteCustomerForm = reduxForm({
  form: FORM_NAME,
})(InviteCustomerForm)

export default InviteCustomerForm
